import { invalid_set } from "./PersonalDataProcess"
import { getDecimalData } from "./utilFuncs"

export const extractPitchData = (data, target) => {
  // console.log(data, target)
  let pitchTypeSet = new Set()
  let output = { left: {}, right: {} }

  let count = { left: 0, right: 0 }
  // console.log(data)
  for (let p of data) {
    // filtered out non essential data
    if (['', 'UN', '?', null].includes(p.TaggedPitchType)) continue
    let side = parseInt(p[target]) === 1 ? 'left' : 'right'
    pitchTypeSet.add(p.TaggedPitchType)
    if (output[side][p.TaggedPitchType] === undefined) output[side][p.TaggedPitchType] = []
    // pack zone chart data
    if (!(invalid_set.includes(p.APP_KZoneY) && invalid_set.includes(p.APP_KZoneZ))) {
      output[side][p.TaggedPitchType].push({ x: p.APP_KZoneY, y: p.APP_KZoneZ })
    }
    count[side]++
  }

  let usage = { left: [], right: [] }

  for (const s in output) {
    for (const t in output[s]) {
      usage[s].push({ tag: t, usage: getDecimalData(output[s][t].length * 100, count[s], 0) })
    }
  }

  pitchTypeSet = Array.from(pitchTypeSet)
  // console.log(output)
  return { zone: output, usage, pitchTypeSet }
}

export const getYearMonthFromDateString = (date) => {
  let time = new Date(date)
  return { y: time.getFullYear(), m: time.getMonth() + 1 }
}

export const wrapPBPData = (data) => {
  // console.log(data)
  let newPlay = true, playPitchCount = 0, playData = []
  for (const p of data) {
    // console.log(p)
    // if (p.TaggedPitchType === undefined || p.TaggedPitchType === null) continue
    let v = parseFloat(p.APP_VeloRel), s = parseFloat(p.SpinRate), se = parseFloat(p.SpinEFF), g = parseInt(p.Gyro), vb = parseFloat(p.InducedVertBeak), hb = parseFloat(p.HorzBreak)
    let zx = parseFloat(p.APP_KZoneY), zy = parseFloat(p.APP_KZoneZ), lx = parseFloat(p.LocX), ly = parseFloat(p.LocY), rs = parseFloat(p.ReleaseSide), rh = parseFloat(p.ReleaseHeight)
    let ym = getYearMonthFromDateString(p.Date)
    if (newPlay) {
      // create a new play if the newPlay flag is set
      let initPlay = {
        pitcher: p.Pitcher, pitcherSide: p.PT === 0 ? 'R' : 'L', batter: p.Batter, batterSide: p.BatS === 0 ? 'R' : 'L', outs: p.Outs,
        date: p.Date, fieldGraphData: [], zoneGraphData: {}, pbp: [], playResult: { result: '-', ev: '-', la: '-' },
        gameNo: p.GameNo, inn: p.Inning, year: ym.y, month: ym.m
      }
      playData.push(initPlay)
      newPlay = false
      playPitchCount = 1;
    }
    // update the last created play
    let pitch = { tag: p.TaggedPitchType, speed: '-', call: p.PitchCode }
    if (!isNaN(v) && v > 0) pitch.speed = getDecimalData(v, 1, 1)
    playData.at(-1).pbp.push(pitch)
    if (playData.at(-1).zoneGraphData[p.TaggedPitchType] === undefined) playData.at(-1).zoneGraphData[p.TaggedPitchType] = []
    if ((!isNaN(zx) && !isNaN(zy)) && (zx !== 0 || zy !== 0)) playData.at(-1).zoneGraphData[p.TaggedPitchType].push({ x: zx, y: zy, v: getDecimalData(v, 1, 1), n: playPitchCount })
    playPitchCount++;
    if (p.PA_Result !== undefined && p.PA_Result[0] !== undefined) {
      // obtain a play result means next pitch is in a new play
      newPlay = true
      let ev = parseFloat(p.ExitVelo), la = parseFloat(p.ExitAngle)
      if (!isNaN(ev) && ev > 0) playData.at(-1).playResult.ev = getDecimalData(ev, 1, 1)
      if (!isNaN(ev) && ev > 0 && !isNaN(la)) playData.at(-1).playResult.la = getDecimalData(la, 1, 1)
      playData.at(-1).playResult.result = p.PA_Result
      if ((!isNaN(lx) && !isNaN(ly)) && (lx !== 0 || ly !== 0)) {
        playData.at(-1).fieldGraphData[['1B', '2B', '3B', 'HR', 'IHR'].includes(p.PA_Result) ? 'HIT' : 'OUT'] = [{ x: lx, y: ly }]
      }
    }
  }

  let packed = {}

  // pack play data according to inning
  for (const i of playData) {
    if (packed[i.inn] === undefined) packed[i.inn] = []
    packed[i.inn].push(i)
  }

  // console.log(packed)

  return packed
}